import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import styles from "./styles.tsx"

const BatchListTable = ({ medicineBatchList, WarningIcon, WarningIconYellow, ColorPallet, BatchListHeaders }) => {
    return (
        <>
            <Typography variant="h6" gutterBottom sx={{ mt: 1 }}>
                Batch List
            </Typography>
            <TableContainer>
                <Table sx={styles.table} stickyHeader>
                    <TableHead sx={styles.tableHead}>
                        <TableRow>
                            {BatchListHeaders.map((item) => (
                                <TableCell
                                    key={item.title}
                                    sx={styles.tableCell(ColorPallet)}
                                >
                                    {item.title}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {medicineBatchList?.map((entry, index) => {
                            const currentDate = new Date();
                            const expiryDate = new Date(entry?.expiry_date);
                            // Convert expiry_reminder months into days
                            const reminderMonths = entry?.expiry_reminder
                                ? parseInt(entry.expiry_reminder, 10)
                                : 6;
                            const reminderDays = reminderMonths * 30; // Approximate each month as 30 days

                            const daysUntilExpiry = Math?.floor(
                                (expiryDate?.getTime() - currentDate?.getTime()) /
                                (1000 * 60 * 60 * 24)
                            );
                            let expireIcon = null;

                            if (daysUntilExpiry < 0) {
                                // Medicine is expired
                                expireIcon = <WarningIcon />;
                            } else if (daysUntilExpiry <= reminderDays) {
                                // Medicine is near expiry
                                expireIcon = <WarningIconYellow />;
                            }

                            const cellStyle = (baseStyle) =>
                                entry?.returned
                                    ? { ...baseStyle, ...styles.lineThrough }
                                    : baseStyle;

                            return (
                                <TableRow key={index}>
                                    <TableCell sx={cellStyle(styles.batchNumberCell(ColorPallet))}>
                                        <span style={{ cursor: "pointer" }}>{entry?.batch_number}</span>
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        {entry?.total_box}
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        {entry?.unit_per_box}
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        {entry?.quantity}
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        {entry?.remaining_quantity}
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        Rs {entry?.sell_price}
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        {entry?.shelf_name}
                                    </TableCell>
                                    <TableCell sx={cellStyle(styles.tableCell(ColorPallet))}>
                                        <Box sx={styles.flexBox}>
                                            {expireIcon}
                                            {entry?.expiry_date
                                                ? new Date(entry?.expiry_date)?.toLocaleDateString()
                                                : ""}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default BatchListTable; 